const templates = [
  {
    id: "classic-pink",
    name: "Classic Pink",
    accentColor: "#ec4899",
    background: "bg-gradient-to-br from-pink-100 to-pink-200",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
    preview: "/templates/classic-pink.jpg",
  },
  {
    id: "balloon-party",
    name: "Balloon Party",
    accentColor: "#fbbf24",
    background: "bg-gradient-to-r from-yellow-100 to-orange-200",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
    preview: "/templates/balloon-party.jpg",
  },
  {
    id: "glow-night",
    name: "Glow Night",
    accentColor: "#7c3aed",
    background: "bg-gradient-to-br from-gray-800 to-indigo-900 text-white",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
    preview: "/templates/glow-night.jpg",
  },
  {
    id: "sparkle_purple",
    name: "Sparkle Purple",
    background: "bg-gradient-to-br from-purple-300 to-purple-500",
    preview: "/templates/sparkle_purple.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "balloons_sky",
    name: "Balloons Sky",
    background: "bg-gradient-to-br from-blue-300 to-blue-500",
    preview: "/templates/balloons_sky.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "sunset_wave",
    name: "Sunset Wave",
    background: "bg-gradient-to-br from-orange-300 to-orange-500",
    preview: "/templates/sunset_wave.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "cotton_candy",
    name: "Cotton Candy",
    background: "bg-gradient-to-br from-pink-200 to-pink-400",
    preview: "/templates/cotton_candy.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "forest_magic",
    name: "Forest Magic",
    background: "bg-gradient-to-br from-emerald-300 to-emerald-600",
    preview: "/templates/forest_magic.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "night_lights",
    name: "Night Lights",
    background: "bg-gradient-to-br from-indigo-800 to-blue-900",
    preview: "/templates/night_lights.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "lemon_fizz",
    name: "Lemon Fizz",
    background: "bg-gradient-to-br from-yellow-200 to-yellow-400",
    preview: "/templates/lemon_fizz.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "cherry_blast",
    name: "Cherry Blast",
    accentColor: "#ef4444",
    background: "bg-gradient-to-br from-red-300 to-red-500",
    preview: "/templates/cherry_blast.jpg",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "elegant-gold",
    name: "Elegant Gold",
    accentColor: "#d97706",
    background: "bg-gradient-to-br from-stone-950 via-stone-800 to-amber-700 text-white",
    previewClass: "bg-gradient-to-br from-stone-950 via-stone-800 to-amber-600",
    animations: {
      confetti: false,
      sparkles: true,
      balloons: false,
    },
  },
  {
    id: "retirement-navy",
    name: "Retirement Navy",
    accentColor: "#38bdf8",
    background: "bg-gradient-to-br from-slate-950 via-blue-950 to-slate-800 text-white",
    previewClass: "bg-gradient-to-br from-slate-950 via-blue-950 to-slate-700",
    animations: {
      confetti: true,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "celebration-bright",
    name: "Celebration Bright",
    accentColor: "#f97316",
    background: "bg-gradient-to-br from-fuchsia-400 via-orange-300 to-yellow-200",
    previewClass: "bg-gradient-to-br from-fuchsia-400 via-orange-300 to-yellow-200",
    animations: {
      confetti: true,
      sparkles: true,
      balloons: false,
    },
  },
  {
    id: "soft-pastel",
    name: "Soft Pastel",
    accentColor: "#8b5cf6",
    background: "bg-gradient-to-br from-rose-100 via-violet-100 to-sky-100",
    previewClass: "bg-gradient-to-br from-rose-100 via-violet-100 to-sky-100",
    animations: {
      confetti: false,
      sparkles: true,
      balloons: false,
    },
  },
  {
    id: "night-party",
    name: "Night Party",
    accentColor: "#22d3ee",
    background: "bg-gradient-to-br from-black via-purple-950 to-cyan-950 text-white",
    previewClass: "bg-gradient-to-br from-black via-purple-950 to-cyan-900",
    animations: {
      confetti: true,
      sparkles: true,
      balloons: false,
    },
  },
  {
    id: "irish-green",
    name: "Irish Green",
    accentColor: "#22c55e",
    background: "bg-gradient-to-br from-emerald-900 via-green-700 to-lime-300 text-white",
    previewClass: "bg-gradient-to-br from-emerald-900 via-green-700 to-lime-300",
    animations: {
      confetti: true,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "minimal-white",
    name: "Minimal White",
    accentColor: "#111827",
    background: "bg-gradient-to-br from-white via-slate-100 to-zinc-200",
    previewClass: "bg-gradient-to-br from-white via-slate-100 to-zinc-200",
    animations: {
      confetti: false,
      sparkles: false,
      balloons: false,
    },
  },
  {
    id: "photo-wall",
    name: "Photo Wall",
    accentColor: "#db2777",
    background: "bg-gradient-to-br from-zinc-900 via-rose-950 to-zinc-800 text-white",
    previewClass: "bg-gradient-to-br from-zinc-900 via-rose-950 to-zinc-700",
    animations: {
      confetti: false,
      sparkles: true,
      balloons: false,
    },
  },
];

export default templates;
